type Breakpoint = {
    size: string
    isActive: boolean
    slidesPerView?: number
    spaceBetween?: number
}

const getActiveBreakpoint = (breakpointsConfig: Breakpoint[]): Breakpoint =>
    breakpointsConfig[breakpointsConfig.findIndex(bp => !bp.isActive) - 1] ??
    breakpointsConfig[breakpointsConfig.length - 1]

export default getActiveBreakpoint
